import type { Product } from '../types';

/** Slug da un'etichetta merceologica ERP con prefisso numerico (es.
 * "090 - Unità Developer" → "unita-developer") — usata sia per il gruppo
 * (30 valori, tassonomia del filtro Tipologia) sia per il sottogruppo (55
 * valori, legacy link di navigazione). Deve rimanere identica alla
 * funzione Python ``_slugify`` in ``backend/products/router.py``. */
export function merceologicoSlug(label?: string | null): string {
  if (!label) return '';
  const m = label.trim().match(/^\d+\s*-\s*(.+)$/);
  const name = (m ? m[1] : label).trim();
  return name
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}

/** Vero se il prodotto appartiene al gruppo o sottogruppo merceologico
 * indicato da `tipologiaSlug` (30 gruppi aggregati, stessa tassonomia della
 * "Ricerca avanzata", oppure — per i link legacy di navigazione — uno dei
 * 55 sottogruppi granulari). Usata da tutte le pagine con filtro Tipologia
 * lato client (ricerca per modello, Outlet) — condivisa per evitare
 * divergenze tra pagine (bug 25/08/2026: Outlet confrontava `p.category`,
 * lo slug legacy a 5 valori, invece del gruppo/sottogruppo reale). */
export function matchesTipologia(product: Product, tipologiaSlug: string): boolean {
  if (!tipologiaSlug) return true;
  const gruppo = merceologicoSlug(product.erp?.detail?.gruppo?.label);
  const sottogruppo = merceologicoSlug(product.erp?.detail?.sottogruppo?.label);
  return gruppo === tipologiaSlug || sottogruppo === tipologiaSlug;
}
